import ioc from '@Framework/ioc';
export default function installDependencies() {
    ioc.get('config.dependencies').forEach(([name, dependencyInitializer, options]) => {
        ioc.set(name, dependencyInitializer, options);
    });
}
